import React, { useState } from 'react';
import "./home-page.css"
import NavBar from '../ui/Navbar/Navbar';
import SideBar from '../ui/SideBar/SideBar';
import HeroSection from '../HeroSection/HeroSection';
import { useSprings, animated } from 'react-spring'
import { InfoSection } from '../InfoSection/InfoSection';
import { HomePageContainer } from "./HomePageElements";
import { AboutSection } from '../AboutSection/AboutSection';
import Footer from '../ui/Footer/Footer';
export default function HomePage() {

  const [isOpen, setisOpen] = useState(false);

  const toggle = () => {
    setisOpen(!isOpen)
  }
  return (
    <>
      <NavBar toggle={toggle} />
      <SideBar isOpen={isOpen} toggle={toggle} />
      <HomePageContainer>
        <HeroSection />
        <InfoSection />
        <AboutSection/>
        <Footer/>
      </HomePageContainer>
    </>

  )
}

